export default "__VITE_ASSET__sSeJ2VNP__"